import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { MapPin, Phone, Mail, Clock, Facebook, Instagram } from 'lucide-react';
export function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    inquiry: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic will be added later
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <Layout data-id="element-168">
      {/* Hero Section */}
      <section className="relative py-32 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100 border-b border-taupe-200" data-id="element-169">
        <div className="max-w-4xl mx-auto text-center" data-id="element-170">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-171">
            Get in Touch
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-172">
            Let's Create Something
            <br data-id="element-173" />
            <span className="italic" data-id="element-174">Beautiful Together</span>
          </h1>
          <p className="text-xl text-charcoal-900/70 leading-relaxed max-w-2xl mx-auto" data-id="element-175">
            Whether you're ready to start a project or just exploring ideas,
            we'd love to hear from you.
          </p>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-24 px-4 bg-white" data-id="element-176">
        <div className="max-w-7xl mx-auto" data-id="element-177">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-178">
            {/* Contact Form */}
            <div className="lg:col-span-2" data-id="element-179">
              <div className="bg-cream-50 p-8 md:p-12 border border-taupe-200 shadow-card" data-id="element-180">
                <h2 className="text-2xl font-serif text-charcoal-900 mb-2" data-id="element-181">
                  Send Us a Message
                </h2>
                <p className="text-charcoal-900/60 mb-8" data-id="element-182">
                  Fill out the form below and we'll get back to you within 24
                  hours.
                </p>

                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-183">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-184">
                    <div data-id="element-185">
                      <label htmlFor="firstName" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-186">
                        First Name *
                      </label>
                      <input type="text" id="firstName" name="firstName" required value={formData.firstName} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors" placeholder="Jane" data-id="element-187" />
                    </div>
                    <div data-id="element-188">
                      <label htmlFor="lastName" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-189">
                        Last Name *
                      </label>
                      <input type="text" id="lastName" name="lastName" required value={formData.lastName} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors" placeholder="Doe" data-id="element-190" />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-191">
                    <div data-id="element-192">
                      <label htmlFor="email" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-193">
                        Email Address *
                      </label>
                      <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors" placeholder="jane@example.com" data-id="element-194" />
                    </div>
                    <div data-id="element-195">
                      <label htmlFor="phone" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-196">
                        Phone Number
                      </label>
                      <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors" placeholder="(555) 123-4567" data-id="element-197" />
                    </div>
                  </div>

                  <div data-id="element-198">
                    <label htmlFor="inquiry" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-199">
                      Reason for Inquiry *
                    </label>
                    <select id="inquiry" name="inquiry" required value={formData.inquiry} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors" data-id="element-200">
                      <option value="" data-id="element-201">Select an option</option>
                      <option value="interior-design" data-id="element-202">Interior Design</option>
                      <option value="staging" data-id="element-203">Staging</option>
                      <option value="window-treatments" data-id="element-204">
                        Window Treatments
                      </option>
                      <option value="retail" data-id="element-205">Retail / Product Question</option>
                      <option value="other" data-id="element-206">Other</option>
                    </select>
                  </div>

                  <div data-id="element-207">
                    <label htmlFor="message" className="block text-sm font-medium text-charcoal-900 mb-2" data-id="element-208">
                      Message *
                    </label>
                    <textarea id="message" name="message" required rows={6} value={formData.message} onChange={handleChange} className="w-full px-4 py-3 bg-white border border-taupe-300 focus:border-sage-500 focus:ring-1 focus:ring-sage-500 outline-none transition-colors resize-none" placeholder="Tell us about your project or question..." data-id="element-209" />
                  </div>

                  <div className="pt-4" data-id="element-210">
                    <Button type="submit" size="lg" fullWidth data-id="element-211">
                      Send Message
                    </Button>
                    <p className="text-sm text-charcoal-900/60 text-center mt-4" data-id="element-212">
                      We typically respond within 24 hours during business days.
                    </p>
                  </div>
                </form>
              </div>
            </div>

            {/* Contact Information Sidebar */}
            <div className="space-y-6" data-id="element-213">
              <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-214">
                <div className="flex items-start gap-3 mb-4" data-id="element-215">
                  <MapPin className="text-sage-500 flex-shrink-0 mt-1" size={20} data-id="element-216" />
                  <div data-id="element-217">
                    <h3 className="font-serif text-lg text-charcoal-900 mb-2" data-id="element-218">
                      Visit Us
                    </h3>
                    <address className="not-italic text-charcoal-900/70 text-sm leading-relaxed" data-id="element-219">
                      2729 E. Grand River Ave.
                      <br data-id="element-220" />
                      Howell, MI 48843
                    </address>
                  </div>
                </div>
                <a href="https://www.google.com/maps/search/?api=1&query=2729+E.+Grand+River+Ave.+Howell+MI+48843" target="_blank" rel="noopener noreferrer" data-id="element-221">
                  <Button variant="ghost" size="sm" fullWidth className="mt-2" data-id="element-222">
                    Get Directions
                  </Button>
                </a>
              </div>

              <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-223">
                <div className="flex items-start gap-3 mb-4" data-id="element-224">
                  <Phone className="text-sage-500 flex-shrink-0 mt-1" size={20} data-id="element-225" />
                  <div data-id="element-226">
                    <h3 className="font-serif text-lg text-charcoal-900 mb-2" data-id="element-227">
                      Call Us
                    </h3>
                    <p className="text-charcoal-900/70 text-sm" data-id="element-228">
                      (555) 123-4567
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-229">
                <div className="flex items-start gap-3 mb-4" data-id="element-230">
                  <Mail className="text-sage-500 flex-shrink-0 mt-1" size={20} data-id="element-231" />
                  <div data-id="element-232">
                    <h3 className="font-serif text-lg text-charcoal-900 mb-2" data-id="element-233">
                      Email Us
                    </h3>
                    <p className="text-charcoal-900/70 text-sm" data-id="element-234">
                      hello@downhomeinteriors.com
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-235">
                <div className="flex items-start gap-3 mb-4" data-id="element-236">
                  <Clock className="text-sage-500 flex-shrink-0 mt-1" size={20} data-id="element-237" />
                  <div data-id="element-238">
                    <h3 className="font-serif text-lg text-charcoal-900 mb-3" data-id="element-239">
                      Store Hours
                    </h3>
                    <div className="space-y-2 text-sm text-charcoal-900/70" data-id="element-240">
                      <div className="flex justify-between" data-id="element-241">
                        <span data-id="element-242">Mon – Fri</span>
                        <span data-id="element-243">10am – 6pm</span>
                      </div>
                      <div className="flex justify-between" data-id="element-244">
                        <span data-id="element-245">Saturday</span>
                        <span data-id="element-246">10am – 4pm</span>
                      </div>
                      <div className="flex justify-between" data-id="element-247">
                        <span data-id="element-248">Sunday</span>
                        <span data-id="element-249">Closed</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 border border-taupe-200 shadow-card" data-id="element-250">
                <h3 className="font-serif text-lg text-charcoal-900 mb-4" data-id="element-251">
                  Follow Us
                </h3>
                <div className="flex gap-4" data-id="element-252">
                  <a href="https://www.facebook.com/DownTowneApparel/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-sage-100 hover:bg-sage-200 flex items-center justify-center transition-colors" aria-label="Facebook" data-id="element-253">
                    <Facebook className="text-sage-600" size={20} data-id="element-254" />
                  </a>
                  <a href="https://www.instagram.com/downhomeinteriors/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-sage-100 hover:bg-sage-200 flex items-center justify-center transition-colors" aria-label="Instagram" data-id="element-255">
                    <Instagram className="text-sage-600" size={20} data-id="element-256" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="py-16 px-4 bg-cream-100" data-id="element-257">
        <div className="max-w-7xl mx-auto" data-id="element-258">
          <div className="h-[500px] bg-taupe-300 flex items-center justify-center text-charcoal-900/30 text-xl font-serif border border-taupe-200 shadow-card" data-id="element-259">
            <div className="text-center p-8" data-id="element-260">
              <MapPin className="mx-auto mb-4 text-charcoal-900/20" size={48} data-id="element-261" />
              <p data-id="element-262">[Google Maps Embed Placeholder]</p>
              <p className="text-sm mt-4 text-charcoal-900/20" data-id="element-263">
                {/* Replace with: <iframe src="https://www.google.com/maps/embed?pb=..." width="100%" height="500" ... */}
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>;
}